import React, { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import { Paperclip } from "@phosphor-icons/react";
import AttachmentsPanel from "./AttachmentsPanel";

export default function AttachmentsButton({ entityType, entityId, label, testId, size = "sm" }) {
  const [open, setOpen] = useState(false);
  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <button
          className="p-1.5 rounded hover:bg-secondary text-muted-foreground hover:text-foreground"
          title="Files"
          data-testid={testId || `attach-btn-${entityId}`}
        >
          <Paperclip size={size === "sm" ? 14 : 16} weight="duotone" />
        </button>
      </DialogTrigger>
      <DialogContent className="max-w-2xl max-h-[85vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle>{label || "Files & documents"}</DialogTitle>
        </DialogHeader>
        <AttachmentsPanel entityType={entityType} entityId={entityId} />
      </DialogContent>
    </Dialog>
  );
}
